import createAPI from './create-api';
const api = createAPI(process.env.MUJI_APP_SSO_HOST, {
  showNotification: false,
});
export async function getSSOUserInfo() {
  return api.jsonp('httpApi/getAuthZ.jsonp');
}
